<script>
import isObject from 'lodash-es/isObject';

export default {
    props: {
        startValue: String,
        dataProp: String,
    },
    data() {
        return {
            container: { [this.field]: this.startValue },
            validationError: null,
        };
    },
    computed: {
        hasError() {
            return !!this.validationError;
        },
        datamodelField() {
            return $(this.$el).datamodel().getField(this.field);
        },
        datamodelFieldInput() {
            return this.datamodelField.getInput();
        },
    },
    mounted() {
        this.datamodelField.addHandler('validation-error', error => {
            this.validationError = error;
        });

        this.datamodelField.addHandler('set-value', value => {
            this.setTime(value);
        });

        this.datamodelField.addHandler('set-enabled', value => {
            this.input.prop('disabled', !value);
        });

        this.$watch(this.dataProp, function (value) {
            if (isObject(value)) {
                value = JSON.stringify(value);
            }

            this.datamodelFieldInput.val(value).change();
        });
    },
};
</script>
